import { render, staticRenderFns } from "./CardAction.vue?vue&type=template&id=0c1d1e88&"
import script from "./CardAction.vue?vue&type=script&lang=js&"
export * from "./CardAction.vue?vue&type=script&lang=js&"
import style0 from "./CardAction.vue?vue&type=style&index=0&id=0c1d1e88&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon})
